export default {
  dbh_url_collection_shortcuts_title: 'My Shortcuts',
  dbh_url_collection_new_features_title: 'New Features',
  dbh_url_collection_edit: 'Edit',
  dbh_url_collection_more: 'More',
  dbh_url_collection_edit_modal_title: 'Edit My Shortcuts',
  dbh_url_collection_add_shortcut: 'Add Shortcut',
  dbh_url_collection_max_count_message: 'Maximum limit of 6 favorites reached. Remove an item to add a new one.',
  dbh_url_collection_delete_confirm_title: 'Are you sure you want to delete it?',
  dbh_url_collection_rename: 'Rename',
  dbh_url_collection_delete: 'Delete',
  dbh_url_collection_name_required: 'Name is required.',
  dbh_url_collection_name_too_long: 'Name must be 80 characters or fewer.',
  dbh_url_collection_duplicate_name: 'This name has already been used.',
  dbh_url_collection_duplicate_url: 'This page has already been added.',
  dbh_url_collection_url_required: 'Please enter a DataBrain page URL.',
  dbh_url_collection_analyse_failed: 'Failed to analyse this URL. Please try again.',
  dbh_url_collection_invalid_system: 'Unsupported system code.',
  dbh_url_collection_save_success: 'Saved successfully!',
  dbh_url_collection_save_failed: 'Failed to save shortcuts.',
  dbh_url_collection_analyse_modal_title: 'Add to Shortcuts',
  dbh_url_collection_analyse_modal_url_label: 'URL',
  dbh_url_collection_analyse_modal_url_placeholder: 'Please enter a DataBrain page URL',
  dbh_url_collection_analyse_modal_import: 'Import',
  dbh_url_collection_analyse_modal_auto_import: 'Auto\nImport',
  dbh_url_collection_analyse_modal_page_name_label: 'Name',
  dbh_url_collection_analyse_modal_page_name_placeholder: 'Auto-filled after URL identification',
  dbh_url_collection_analyse_modal_identify_success: 'Identified Successfully!',
  dbh_url_collection_analyse_modal_preview_empty: 'Import a DataBrain URL to preview shortcut information here.',
  dbh_url_collection_analyse_modal_no_permission:
    'Unable to add this shortcut because you do not have permission to access this URL.',
  dbh_url_collection_analyse_modal_unavailable:
    'This page is unavailable, or the linked entity is no longer available.',
  dbh_url_collection_analyse_modal_invalid: 'Only DataBrain URLs can be imported. Please check the link and try again.',
  dbh_url_collection_analyse_modal_preview_link: 'Preview page',
  dbh_url_collection_analyse_modal_path_label: 'Path',
  dbh_url_collection_analyse_modal_url_value_label: 'URL',
  dbh_url_collection_analyse_modal_system_benchmark: 'Benchmark',
  dbh_url_collection_analyse_modal_name_error: 'Auto-filled after URL identification',
  dbh_url_collection_analyse_modal_name_error_unsupported: 'Unsupported Link. Please use a supported game page URL.',
  dbh_url_collection_analyse_modal_name_error_no_permission:
    'Unable to add this shortcut. You do not have permission to access this URL.',
  dbh_url_collection_shortcuts_empty: 'Save your favourite pages and use one click to go!',
  dbh_url_collection_new_features_empty: 'Stay tuned for new feature updates.',
};
